import React, { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  MenuItem,
  Grid,
  Button,
  CircularProgress,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useSelector } from 'react-redux';

const TroubleInPayment = ({ open, handleClose, transactionStatusToastMessage }) => {
  const [selectedIssue, setSelectedIssue] = useState('');
  const [customerQuery, setCustomerQuery] = useState('');
  const [loading, setLoading] = useState(false);
    const {fosId,email,name,contactNumber} = useSelector((state) => state.Auth.user);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: '#fff',
    borderRadius: 2,
    width: isMobile ? 'calc(75% - 32px)' : 400,
    p: isMobile ? 2 : 4,
    maxHeight: '90vh',
    overflowY: 'auto',
    marginLeft: isMobile ? '4px' : 'auto',
    marginRight: isMobile ? '16px' : 'auto',
  };

  const handleSubmit = async () => {
    if (!selectedIssue) {
      toast.error('Please select an issue type.');
      return;
    }

    if (selectedIssue === 'Other' && customerQuery.trim() === '') {
      toast.error('Please describe the issue.');
      return;
    }

    setLoading(true);

    try {
    console.log("payloadddddd=======",typeof(contactNumber));
      const payload = {
        email: email,
        id: fosId,
        mobile: contactNumber ? contactNumber.toString() : "",
        name: name,
        payment_error_message: transactionStatusToastMessage || null,
        payment_issue_type: selectedIssue,
        // project: 'PALLADIO P-2',
        query: selectedIssue === 'Other' ? customerQuery.trim() : '',
        status: 'open',
        // unit: '0107',
        // wing: 'E',
      };

      const response = await axios.post(
        `${process.env.REACT_APP_VJONEPARIVAAR_API_URL}/fosWallet/addFosTroubleInPaymentQuery`,
        payload
      );

      console.log('API Response:', response.data);
      toast.success('Query submitted successfully.');
      handleClose();
    } catch (error) {
      console.error('Submission error:', error);
      toast.error('Failed to submit query. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="h6" fontWeight="bold" fontSize={{ xs: '1.9rem', sm: '1.80rem' }}>
              Trouble in Payment?
            </Typography>
            <Typography variant="body2" color="text.secondary" fontSize={{ xs: '1.555rem', sm: '1.30rem' }}>
              Don&apos;t worry, we are here to help you.
            </Typography>
          </Box>
          <IconButton onClick={handleClose}>
            <CloseIcon fontSize="large" />
          </IconButton>
        </Box>

        <Typography variant="body2" mt={2} mb={2} fontSize={{ xs: '1.525rem', sm: '1.25rem' }}>
          Choose the issue you're facing from the dropdown below and submit your request.
        </Typography>

        <Grid container spacing={2}>
          {/* <Grid item xs={12}>
            <TextField
              fullWidth
              select
              label="Select your issue type *"
              value={selectedIssue}
              onChange={(e) => setSelectedIssue(e.target.value)}
              InputProps={{ style: { fontSize: '1.125rem' } }}
              InputLabelProps={{ style: { fontSize: '1.125rem' } }}
            >
              <MenuItem value="Name mismatch.">Name mismatch.</MenuItem>
              <MenuItem value="Insufficient redeemable points">Insufficient redeemable points</MenuItem>
              <MenuItem value="Account-related issue.">Account-related issue.</MenuItem>
              <MenuItem value="Technical issue.">Technical issue.</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </TextField>
          </Grid> */}
           <Grid item xs={12}>
  <TextField
    fullWidth
    select
    label="Select your issue type *"
    value={selectedIssue}
    onChange={(e) => setSelectedIssue(e.target.value)}
    InputProps={{
      style: { fontSize: '2rem' } // larger font size for selected text
    }}
    InputLabelProps={{
      style: { fontSize: '2rem' } // larger font size for placeholder/label
    }}
    SelectProps={{
      MenuProps: {
        PaperProps: {
          style: {
            maxHeight: 240, // increase dropdown height optionally
          },
        },
      },
    }}
  >
    <MenuItem value="Name mismatch." sx={{ fontSize: '2rem' }}>
      Name mismatch.
    </MenuItem>
    <MenuItem value="Insufficient redeemable points" sx={{ fontSize: '2rem' }}>
      Insufficient redeemable points
    </MenuItem>
    <MenuItem value="Account-related issue." sx={{ fontSize: '2rem' }}>
      Account-related issue.
    </MenuItem>
    <MenuItem value="Technical issue." sx={{ fontSize: '2rem' }}>
      Technical issue.
    </MenuItem>
    <MenuItem value="Other" sx={{ fontSize: '2rem' }}>
      Other
    </MenuItem>
  </TextField>
</Grid>

          {selectedIssue === 'Other' && (
            // <Grid item xs={12}>
            //   <TextField
            //     fullWidth
            //     label="Describe your issue *"
            //     placeholder="Please describe the issue you're having..."
            //     multiline
            //     rows={4}
            //     value={customerQuery}
            //     onChange={(e) => setCustomerQuery(e.target.value)}
            //     InputProps={{ style: { fontSize: '1.125rem' } }}
            //     InputLabelProps={{ style: { fontSize: '1.125rem' } }}
            //   />
            // </Grid>
            <Grid item xs={12}>
  <TextField
    fullWidth
    label="Describe your issue *"
    placeholder="Please describe the issue you're having..."
    multiline
    rows={4}
    value={customerQuery}
    onChange={(e) => setCustomerQuery(e.target.value)}
    InputProps={{ style: { fontSize: '2rem', lineHeight: 1.5 } }} // Larger font & better line height for readability
    InputLabelProps={{ style: { fontSize: '2rem' } }}
  />
</Grid>

          )}
        </Grid>

        <Box display="flex" justifyContent="flex-end" mt={3} gap={2}>
          <Button variant="outlined" onClick={handleClose} sx={{ fontSize: '1.25rem' }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            sx={{
              backgroundColor: '#1976D2',
              '&:hover': { backgroundColor: '#1565c0' },
              minWidth: isMobile ? '100%' : '140px',
              fontSize: { xs: '1.526rem', sm: '1.25rem' },
              py: 1.4,
            }}
          >
            {loading ? <CircularProgress size={26} /> : 'Submit query'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default TroubleInPayment;